// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-3 {
    grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.grid-4 {
    grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.grid-5 {
    grid-template-columns: repeat(auto-fit, minmax(15%, 1fr));
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.grid-7{
    grid-template-columns: repeat(auto-fit, minmax(12%, 1fr));
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.grid-8 {
    grid-template-columns: repeat(auto-fit, minmax(10%, 1fr));
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.grid-2 {
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.grid-3-4{
    display: grid;
    grid-template-columns: 1fr .4fr;
}

.dashboard-content {
    width: 100%;
    max-width: 1480px;
    margin: 0 auto;
    flex: 1;
    padding: 0 20px;
}

.activeDomain {
    color: aliceblue;
    text-decoration: none;
    text-transform: uppercase;
}

.user {
    padding: 20px;
    background-color: #fff;
    color: #3d3d3d;
    border-radius: 10px;
}

.profile-user {
    font-size: 30px;
}

.profilePicture-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    background-color: #464646;
    padding: 30px;
    border-radius: 10px;
}

.profilePicture {
    width: 190px;
    height: 190px;
    border-radius: 50%;
    object-fit: cover;
}

.warning{
    margin-right: 10px;
    font-weight: bold;
}

.warning.critical{
    color: red;
}

.warning.high{
    color: orange;
}

.warning.high::before{
    content: "!!";
    margin-right: 5px;
    font-weight: bold;
}

.warning.critical::before {
    content: "!!!";
    margin-right: 5px;
    font-weight: bold;
}

.warning.medium{
    color: yellow;
}
.warning.low{
    color: green;
}

.grid-7 .span-2 {
    grid-column: span 2;
    min-width: 0;
}

.dashboard-marketing-teaser {
    margin: 0 0 16px;
    padding: 10px 14px;
    font-size: 0.9rem;
    line-height: 1.45;
    color: #2a2a2a;
    background: linear-gradient(105deg, #f6f1e8 0%, #f0ebe3 100%);
    border: 1px solid rgba(163, 133, 64, 0.35);
    border-radius: 8px;
}

.dashboard-marketing-teaser p {
    margin: 0;
}

.dashboard-marketing-teaser a {
    font-weight: 600;
    color: #a38540;
    text-decoration: none;
    white-space: nowrap;
}

.dashboard-marketing-teaser a:hover {
    text-decoration: underline;
}

/* ── Dashboard section wrapper ── */
.dashboard-section {
    padding-top: 36px;
}

.dashboard-section-label {
    margin: 0 0 16px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.28);
}

/* ── Hero KPI row (acceptance + essential-only) ── */
.dashboard-hero-kpis {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 12px;
}

.dashboard-hero-kpis .small-widget-number {
    font-size: clamp(2rem, 3.5vw, 2.8rem);
    font-weight: 300;
    letter-spacing: -0.02em;
}

.dashboard-hero-kpis .key-highlight-widget {
    padding: 20px 22px 18px;
}

.dashboard-hero-kpis--loading {
    min-height: 110px;
}

/* ── EU / Non-EU geo stats strip (below map) ── */
.dashboard-geo-stats {
    display: flex;
    align-items: center;
    gap: 0;
    margin-top: 12px;
    padding: 14px 18px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.18);
}

.dashboard-geo-stat {
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex: 1;
    min-width: 0;
}

.dashboard-geo-stat__value {
    font-size: 1.1rem;
    font-weight: 600;
    color: #e8e8e8;
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
}

.dashboard-geo-stat__label {
    font-size: 0.78rem;
    color: rgba(255, 255, 255, 0.35);
    font-weight: 500;
    flex-shrink: 0;
}

.dashboard-geo-stat__rate {
    font-size: 0.75rem;
    color: #c0a053;
    font-weight: 500;
    flex-shrink: 0;
}

.dashboard-geo-stat__divider {
    width: 1px;
    height: 28px;
    background: rgba(255, 255, 255, 0.08);
    flex-shrink: 0;
    margin: 0 20px;
}


/* ── Decision behaviour inline KPI tile ── */
.dashboard-behaviour-kpi {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 18px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.18);
}

.dashboard-behaviour-kpi__content {
    display: flex;
    align-items: baseline;
    gap: 10px;
    min-width: 0;
    flex-wrap: wrap;
}

.dashboard-behaviour-kpi__label {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.32);
    font-weight: 500;
    flex-shrink: 0;
}

.dashboard-behaviour-kpi__value {
    font-size: 1.25rem;
    font-weight: 600;
    color: #e8e8e8;
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
}

.dashboard-behaviour-kpi__sub {
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.22);
    flex-shrink: 0;
}

.dashboard-behaviour-kpi__btn {
    flex-shrink: 0;
    padding: 7px 14px;
    border-radius: 7px;
    border: 1px solid rgba(192, 159, 83, 0.3);
    background: rgba(192, 159, 83, 0.07);
    color: #c0a053;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
    letter-spacing: 0.01em;
}

.dashboard-behaviour-kpi__btn:hover {
    background: rgba(192, 159, 83, 0.14);
    border-color: rgba(192, 159, 83, 0.5);
}

/* ── Compliance / quick-link rows ── */
.dashboard-compliance-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dashboard-compliance-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-radius: 9px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.15);
    text-decoration: none;
    transition: border-color 0.15s ease, background 0.15s ease;
}

.dashboard-compliance-link:hover {
    border-color: rgba(192, 159, 83, 0.3);
    background: rgba(192, 159, 83, 0.05);
    text-decoration: none;
}

.dashboard-compliance-link__label {
    font-size: 0.85rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.65);
}

.dashboard-compliance-link:hover .dashboard-compliance-link__label {
    color: #e8e8e8;
}

.dashboard-compliance-link__arrow {
    font-size: 0.85rem;
    color: rgba(192, 159, 83, 0.6);
    flex-shrink: 0;
    transition: transform 0.15s ease, color 0.15s ease;
}

.dashboard-compliance-link:hover .dashboard-compliance-link__arrow {
    transform: translateX(3px);
    color: #c0a053;
}

/* ── Marketing link (replaces teaser section) ── */
.dashboard-marketing-link {
    margin: 16px 0 0;
    font-size: 0.8125rem;
    color: #666;
}

.dashboard-marketing-link a {
    color: #a38540;
    font-weight: 600;
    text-decoration: none;
}

.dashboard-marketing-link a:hover {
    text-decoration: underline;
}

/* Workspace active banner */
.dashboard-workspace-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    padding: 12px 18px;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.35);
    background: linear-gradient(105deg, rgba(192, 159, 83, 0.1) 0%, rgba(0, 0, 0, 0.2) 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.dashboard-workspace-banner__left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.dashboard-workspace-banner__kicker {
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #c0a053;
    flex-shrink: 0;
}

.dashboard-workspace-banner__name {
    font-size: 0.9rem;
    font-weight: 600;
    color: #f0e6d4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dashboard-workspace-banner__domains {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.dashboard-workspace-banner__domain-tag {
    display: inline-block;
    padding: 3px 9px;
    border-radius: 20px;
    border: 1px solid rgba(192, 159, 83, 0.25);
    background: rgba(192, 159, 83, 0.08);
    font-size: 0.72rem;
    font-weight: 500;
    color: #c0a053;
    white-space: nowrap;
}

.dashboard-workspace-banner__domain-tag--more {
    color: rgba(192, 159, 83, 0.6);
    border-style: dashed;
}

/* Domain Verification Warning Banner */
.dashboard-verification-warning {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    padding: 14px 18px;
    border-radius: 12px;
    background: rgba(220, 160, 60, 0.1);
    border: 1px solid rgba(220, 160, 60, 0.3);
}

.dashboard-verification-warning--expired {
    background: rgba(220, 100, 80, 0.1);
    border-color: rgba(220, 100, 80, 0.3);
}

.dashboard-verification-warning__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    background: rgba(220, 160, 60, 0.2);
    border: 1px solid rgba(220, 160, 60, 0.4);
    color: #e8c76a;
    font-size: 1.25rem;
    font-weight: 700;
}

.dashboard-verification-warning--expired .dashboard-verification-warning__icon {
    background: rgba(220, 100, 80, 0.2);
    border-color: rgba(220, 100, 80, 0.4);
    color: #f0a8a0;
}

.dashboard-verification-warning__content {
    flex: 1;
    min-width: 0;
}

.dashboard-verification-warning__content strong {
    display: block;
    font-size: 0.875rem;
    font-weight: 600;
    color: #e8c76a;
    margin-bottom: 4px;
}

.dashboard-verification-warning--expired .dashboard-verification-warning__content strong {
    color: #f0a8a0;
}

.dashboard-verification-warning__content p {
    margin: 0;
    font-size: 0.8125rem;
    color: rgba(197, 197, 197, 0.85);
    line-height: 1.45;
}

.dashboard-verification-warning__steps {
    margin-top: 6px !important;
    font-size: 0.75rem !important;
    color: rgba(197, 197, 197, 0.55) !important;
}

.dashboard-verification-warning__steps code {
    font-family: ui-monospace, "SFMono-Regular", Menlo, monospace;
    font-size: 0.72rem;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 3px;
    padding: 1px 4px;
}

.dashboard-verification-warning__inline-link {
    color: #e8c76a;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.dashboard-verification-warning__inline-link:hover {
    color: #f5d98a;
}

.dashboard-verification-warning__action {
    flex-shrink: 0;
    padding: 8px 16px;
    border-radius: 8px;
    background: rgba(220, 160, 60, 0.15);
    border: 1px solid rgba(220, 160, 60, 0.35);
    color: #e8c76a;
    font-size: 0.8125rem;
    font-weight: 600;
    text-decoration: none;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.dashboard-verification-warning__action:hover {
    background: rgba(220, 160, 60, 0.25);
    border-color: rgba(220, 160, 60, 0.5);
    text-decoration: none;
}

.dashboard-verification-warning--expired .dashboard-verification-warning__action {
    background: rgba(220, 100, 80, 0.15);
    border-color: rgba(220, 100, 80, 0.35);
    color: #f0a8a0;
}

.dashboard-verification-warning--expired .dashboard-verification-warning__action:hover {
    background: rgba(220, 100, 80, 0.25);
    border-color: rgba(220, 100, 80, 0.5);
}

/* ── Pre-consent scan summary cards ─────────────────────────────────────────── */
.dash-scan-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;
}

.dash-scan-cards__header {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: -4px;
}

.dash-scan-cards__age {
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.3);
    letter-spacing: 0.01em;
}

.dash-scan-cards__age.--stale {
    color: rgba(220, 140, 50, 0.7);
}

.dash-scan-cards__scan-btn {
    font-size: 0.7rem;
    padding: 3px 10px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.55);
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.dash-scan-cards__scan-btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.85);
}

.dash-scan-cards__scan-btn.--loading {
    opacity: 0.5;
    cursor: wait;
}

.dash-scan-card {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 18px 20px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(255, 255, 255, 0.02);
    text-decoration: none;
    color: inherit;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.dash-scan-card:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.12);
}

.dash-scan-card.--warn {
    border-color: rgba(220, 140, 50, 0.2);
    background: rgba(220, 140, 50, 0.04);
}

.dash-scan-card.--warn:hover {
    background: rgba(220, 140, 50, 0.08);
    border-color: rgba(220, 140, 50, 0.3);
}

.dash-scan-card.--stale {
    border-color: rgba(255, 255, 255, 0.05);
    background: rgba(255, 255, 255, 0.02);
    opacity: 0.6;
}

.dash-scan-card.--stale .dash-scan-card__count {
    color: rgba(255, 255, 255, 0.45);
}

.dash-scan-card.--empty {
    opacity: 0.6;
}

.dash-scan-card__top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
}

.dash-scan-card__count {
    font-size: 2.2rem;
    font-weight: 200;
    line-height: 1;
    color: rgba(255, 255, 255, 0.88);
    letter-spacing: -0.03em;
    font-variant-numeric: tabular-nums;
}

.dash-scan-card__icon {
    font-size: 1rem;
    opacity: 0.35;
}

.dash-scan-card__label {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.55);
    letter-spacing: 0.01em;
}

.dash-scan-card__sub {
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.28);
    letter-spacing: 0.01em;
}

.dash-scan-card.--warn .dash-scan-card__sub {
    color: rgba(220, 175, 100, 0.65);
}

@media screen and (max-width: 900px) {
    .dashboard-content {
        padding: 0 20px;
    }

    .grid-3-4 {
        grid-template-columns: 1fr;
    }

    .topWidget{
        display: flex;
        overflow-x: auto;
        justify-content: flex-start;
    }

    .topWidget > * {
        flex: 0 0 auto;
    }

}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/Style.css"],"names":[],"mappings":"AAAA;IACI,yDAAyD;IACzD,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yDAAyD;IACzD,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yDAAyD;IACzD,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yDAAyD;IACzD,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yDAAyD;IACzD,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,6DAA6D;IAC7D,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,oCAAoC;AACpC;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qCAAqC;IACrC,cAAc;IACd,cAAc;AAClB;;;AAGA,6CAA6C;AAC7C;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;IAC/B,qBAAqB;IACrB,0DAA0D;AAC9D;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,kDAAkD;AACtD;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,mDAAmD;AACnD;IACI,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,wFAAwF;IACxF,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,6DAA6D;IAC7D,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,0CAA0C;IAC1C,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,wDAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA,kFAAkF;AAClF;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,qBAAqB;IACrB,cAAc;IACd,0DAA0D;AAC9D;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;IACvC,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,cAAc;IAClB;;AAEJ","sourcesContent":[".grid-3 {\n    grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.grid-4 {\n    grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.grid-5 {\n    grid-template-columns: repeat(auto-fit, minmax(15%, 1fr));\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.grid-7{\n    grid-template-columns: repeat(auto-fit, minmax(12%, 1fr));\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.grid-8 {\n    grid-template-columns: repeat(auto-fit, minmax(10%, 1fr));\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.grid-2 {\n    grid-template-columns: 1fr 1fr;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.grid-3-4{\n    display: grid;\n    grid-template-columns: 1fr .4fr;\n}\n\n.dashboard-content {\n    width: 100%;\n    max-width: 1480px;\n    margin: 0 auto;\n    flex: 1;\n    padding: 0 20px;\n}\n\n.activeDomain {\n    color: aliceblue;\n    text-decoration: none;\n    text-transform: uppercase;\n}\n\n.user {\n    padding: 20px;\n    background-color: #fff;\n    color: #3d3d3d;\n    border-radius: 10px;\n}\n\n.profile-user {\n    font-size: 30px;\n}\n\n.profilePicture-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 30px;\n    background-color: #464646;\n    padding: 30px;\n    border-radius: 10px;\n}\n\n.profilePicture {\n    width: 190px;\n    height: 190px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.warning{\n    margin-right: 10px;\n    font-weight: bold;\n}\n\n.warning.critical{\n    color: red;\n}\n\n.warning.high{\n    color: orange;\n}\n\n.warning.high::before{\n    content: \"!!\";\n    margin-right: 5px;\n    font-weight: bold;\n}\n\n.warning.critical::before {\n    content: \"!!!\";\n    margin-right: 5px;\n    font-weight: bold;\n}\n\n.warning.medium{\n    color: yellow;\n}\n.warning.low{\n    color: green;\n}\n\n.grid-7 .span-2 {\n    grid-column: span 2;\n    min-width: 0;\n}\n\n.dashboard-marketing-teaser {\n    margin: 0 0 16px;\n    padding: 10px 14px;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    color: #2a2a2a;\n    background: linear-gradient(105deg, #f6f1e8 0%, #f0ebe3 100%);\n    border: 1px solid rgba(163, 133, 64, 0.35);\n    border-radius: 8px;\n}\n\n.dashboard-marketing-teaser p {\n    margin: 0;\n}\n\n.dashboard-marketing-teaser a {\n    font-weight: 600;\n    color: #a38540;\n    text-decoration: none;\n    white-space: nowrap;\n}\n\n.dashboard-marketing-teaser a:hover {\n    text-decoration: underline;\n}\n\n/* ── Dashboard section wrapper ── */\n.dashboard-section {\n    padding-top: 36px;\n}\n\n.dashboard-section-label {\n    margin: 0 0 16px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.28);\n}\n\n/* ── Hero KPI row (acceptance + essential-only) ── */\n.dashboard-hero-kpis {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.dashboard-hero-kpis .small-widget-number {\n    font-size: clamp(2rem, 3.5vw, 2.8rem);\n    font-weight: 300;\n    letter-spacing: -0.02em;\n}\n\n.dashboard-hero-kpis .key-highlight-widget {\n    padding: 20px 22px 18px;\n}\n\n.dashboard-hero-kpis--loading {\n    min-height: 110px;\n}\n\n/* ── EU / Non-EU geo stats strip (below map) ── */\n.dashboard-geo-stats {\n    display: flex;\n    align-items: center;\n    gap: 0;\n    margin-top: 12px;\n    padding: 14px 18px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(0, 0, 0, 0.18);\n}\n\n.dashboard-geo-stat {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    flex: 1;\n    min-width: 0;\n}\n\n.dashboard-geo-stat__value {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #e8e8e8;\n    font-variant-numeric: tabular-nums;\n    flex-shrink: 0;\n}\n\n.dashboard-geo-stat__label {\n    font-size: 0.78rem;\n    color: rgba(255, 255, 255, 0.35);\n    font-weight: 500;\n    flex-shrink: 0;\n}\n\n.dashboard-geo-stat__rate {\n    font-size: 0.75rem;\n    color: #c0a053;\n    font-weight: 500;\n    flex-shrink: 0;\n}\n\n.dashboard-geo-stat__divider {\n    width: 1px;\n    height: 28px;\n    background: rgba(255, 255, 255, 0.08);\n    flex-shrink: 0;\n    margin: 0 20px;\n}\n\n\n/* ── Decision behaviour inline KPI tile ── */\n.dashboard-behaviour-kpi {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 14px 18px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(0, 0, 0, 0.18);\n}\n\n.dashboard-behaviour-kpi__content {\n    display: flex;\n    align-items: baseline;\n    gap: 10px;\n    min-width: 0;\n    flex-wrap: wrap;\n}\n\n.dashboard-behaviour-kpi__label {\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.32);\n    font-weight: 500;\n    flex-shrink: 0;\n}\n\n.dashboard-behaviour-kpi__value {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #e8e8e8;\n    font-variant-numeric: tabular-nums;\n    flex-shrink: 0;\n}\n\n.dashboard-behaviour-kpi__sub {\n    font-size: 0.72rem;\n    color: rgba(255, 255, 255, 0.22);\n    flex-shrink: 0;\n}\n\n.dashboard-behaviour-kpi__btn {\n    flex-shrink: 0;\n    padding: 7px 14px;\n    border-radius: 7px;\n    border: 1px solid rgba(192, 159, 83, 0.3);\n    background: rgba(192, 159, 83, 0.07);\n    color: #c0a053;\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease;\n    letter-spacing: 0.01em;\n}\n\n.dashboard-behaviour-kpi__btn:hover {\n    background: rgba(192, 159, 83, 0.14);\n    border-color: rgba(192, 159, 83, 0.5);\n}\n\n/* ── Compliance / quick-link rows ── */\n.dashboard-compliance-links {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.dashboard-compliance-link {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    border-radius: 9px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(0, 0, 0, 0.15);\n    text-decoration: none;\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.dashboard-compliance-link:hover {\n    border-color: rgba(192, 159, 83, 0.3);\n    background: rgba(192, 159, 83, 0.05);\n    text-decoration: none;\n}\n\n.dashboard-compliance-link__label {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.65);\n}\n\n.dashboard-compliance-link:hover .dashboard-compliance-link__label {\n    color: #e8e8e8;\n}\n\n.dashboard-compliance-link__arrow {\n    font-size: 0.85rem;\n    color: rgba(192, 159, 83, 0.6);\n    flex-shrink: 0;\n    transition: transform 0.15s ease, color 0.15s ease;\n}\n\n.dashboard-compliance-link:hover .dashboard-compliance-link__arrow {\n    transform: translateX(3px);\n    color: #c0a053;\n}\n\n/* ── Marketing link (replaces teaser section) ── */\n.dashboard-marketing-link {\n    margin: 16px 0 0;\n    font-size: 0.8125rem;\n    color: #666;\n}\n\n.dashboard-marketing-link a {\n    color: #a38540;\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.dashboard-marketing-link a:hover {\n    text-decoration: underline;\n}\n\n/* Workspace active banner */\n.dashboard-workspace-banner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n    margin-bottom: 16px;\n    padding: 12px 18px;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    background: linear-gradient(105deg, rgba(192, 159, 83, 0.1) 0%, rgba(0, 0, 0, 0.2) 100%);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.dashboard-workspace-banner__left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n}\n\n.dashboard-workspace-banner__kicker {\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.18em;\n    text-transform: uppercase;\n    color: #c0a053;\n    flex-shrink: 0;\n}\n\n.dashboard-workspace-banner__name {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #f0e6d4;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.dashboard-workspace-banner__domains {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.dashboard-workspace-banner__domain-tag {\n    display: inline-block;\n    padding: 3px 9px;\n    border-radius: 20px;\n    border: 1px solid rgba(192, 159, 83, 0.25);\n    background: rgba(192, 159, 83, 0.08);\n    font-size: 0.72rem;\n    font-weight: 500;\n    color: #c0a053;\n    white-space: nowrap;\n}\n\n.dashboard-workspace-banner__domain-tag--more {\n    color: rgba(192, 159, 83, 0.6);\n    border-style: dashed;\n}\n\n/* Domain Verification Warning Banner */\n.dashboard-verification-warning {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 20px;\n    padding: 14px 18px;\n    border-radius: 12px;\n    background: rgba(220, 160, 60, 0.1);\n    border: 1px solid rgba(220, 160, 60, 0.3);\n}\n\n.dashboard-verification-warning--expired {\n    background: rgba(220, 100, 80, 0.1);\n    border-color: rgba(220, 100, 80, 0.3);\n}\n\n.dashboard-verification-warning__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: rgba(220, 160, 60, 0.2);\n    border: 1px solid rgba(220, 160, 60, 0.4);\n    color: #e8c76a;\n    font-size: 1.25rem;\n    font-weight: 700;\n}\n\n.dashboard-verification-warning--expired .dashboard-verification-warning__icon {\n    background: rgba(220, 100, 80, 0.2);\n    border-color: rgba(220, 100, 80, 0.4);\n    color: #f0a8a0;\n}\n\n.dashboard-verification-warning__content {\n    flex: 1;\n    min-width: 0;\n}\n\n.dashboard-verification-warning__content strong {\n    display: block;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #e8c76a;\n    margin-bottom: 4px;\n}\n\n.dashboard-verification-warning--expired .dashboard-verification-warning__content strong {\n    color: #f0a8a0;\n}\n\n.dashboard-verification-warning__content p {\n    margin: 0;\n    font-size: 0.8125rem;\n    color: rgba(197, 197, 197, 0.85);\n    line-height: 1.45;\n}\n\n.dashboard-verification-warning__steps {\n    margin-top: 6px !important;\n    font-size: 0.75rem !important;\n    color: rgba(197, 197, 197, 0.55) !important;\n}\n\n.dashboard-verification-warning__steps code {\n    font-family: ui-monospace, \"SFMono-Regular\", Menlo, monospace;\n    font-size: 0.72rem;\n    background: rgba(255, 255, 255, 0.06);\n    border-radius: 3px;\n    padding: 1px 4px;\n}\n\n.dashboard-verification-warning__inline-link {\n    color: #e8c76a;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n}\n\n.dashboard-verification-warning__inline-link:hover {\n    color: #f5d98a;\n}\n\n.dashboard-verification-warning__action {\n    flex-shrink: 0;\n    padding: 8px 16px;\n    border-radius: 8px;\n    background: rgba(220, 160, 60, 0.15);\n    border: 1px solid rgba(220, 160, 60, 0.35);\n    color: #e8c76a;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    text-decoration: none;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.dashboard-verification-warning__action:hover {\n    background: rgba(220, 160, 60, 0.25);\n    border-color: rgba(220, 160, 60, 0.5);\n    text-decoration: none;\n}\n\n.dashboard-verification-warning--expired .dashboard-verification-warning__action {\n    background: rgba(220, 100, 80, 0.15);\n    border-color: rgba(220, 100, 80, 0.35);\n    color: #f0a8a0;\n}\n\n.dashboard-verification-warning--expired .dashboard-verification-warning__action:hover {\n    background: rgba(220, 100, 80, 0.25);\n    border-color: rgba(220, 100, 80, 0.5);\n}\n\n/* ── Pre-consent scan summary cards ─────────────────────────────────────────── */\n.dash-scan-cards {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.dash-scan-cards__header {\n    grid-column: 1 / -1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: -4px;\n}\n\n.dash-scan-cards__age {\n    font-size: 0.7rem;\n    color: rgba(255, 255, 255, 0.3);\n    letter-spacing: 0.01em;\n}\n\n.dash-scan-cards__age.--stale {\n    color: rgba(220, 140, 50, 0.7);\n}\n\n.dash-scan-cards__scan-btn {\n    font-size: 0.7rem;\n    padding: 3px 10px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    background: rgba(255, 255, 255, 0.04);\n    color: rgba(255, 255, 255, 0.55);\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.dash-scan-cards__scan-btn:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.85);\n}\n\n.dash-scan-cards__scan-btn.--loading {\n    opacity: 0.5;\n    cursor: wait;\n}\n\n.dash-scan-card {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    padding: 18px 20px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(255, 255, 255, 0.02);\n    text-decoration: none;\n    color: inherit;\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.dash-scan-card:hover {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(255, 255, 255, 0.12);\n}\n\n.dash-scan-card.--warn {\n    border-color: rgba(220, 140, 50, 0.2);\n    background: rgba(220, 140, 50, 0.04);\n}\n\n.dash-scan-card.--warn:hover {\n    background: rgba(220, 140, 50, 0.08);\n    border-color: rgba(220, 140, 50, 0.3);\n}\n\n.dash-scan-card.--stale {\n    border-color: rgba(255, 255, 255, 0.05);\n    background: rgba(255, 255, 255, 0.02);\n    opacity: 0.6;\n}\n\n.dash-scan-card.--stale .dash-scan-card__count {\n    color: rgba(255, 255, 255, 0.45);\n}\n\n.dash-scan-card.--empty {\n    opacity: 0.6;\n}\n\n.dash-scan-card__top {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.dash-scan-card__count {\n    font-size: 2.2rem;\n    font-weight: 200;\n    line-height: 1;\n    color: rgba(255, 255, 255, 0.88);\n    letter-spacing: -0.03em;\n    font-variant-numeric: tabular-nums;\n}\n\n.dash-scan-card__icon {\n    font-size: 1rem;\n    opacity: 0.35;\n}\n\n.dash-scan-card__label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.55);\n    letter-spacing: 0.01em;\n}\n\n.dash-scan-card__sub {\n    font-size: 0.68rem;\n    color: rgba(255, 255, 255, 0.28);\n    letter-spacing: 0.01em;\n}\n\n.dash-scan-card.--warn .dash-scan-card__sub {\n    color: rgba(220, 175, 100, 0.65);\n}\n\n@media screen and (max-width: 900px) {\n    .dashboard-content {\n        padding: 0 20px;\n    }\n\n    .grid-3-4 {\n        grid-template-columns: 1fr;\n    }\n\n    .topWidget{\n        display: flex;\n        overflow-x: auto;\n        justify-content: flex-start;\n    }\n\n    .topWidget > * {\n        flex: 0 0 auto;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
